import { StyleSheet } from 'react-native';
import { TextMediumSize, TextSmallSize } from '../../../common/constants/Fonts';

export const trackingTagsStyle = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    backgroundColor: '#f5f7fb',
  },

  dashboardWrapper: {
    flexDirection: 'row',
    width: '100%',
  },

  leftPane: {
    width: 300,
    backgroundColor: '#ffffff',
    borderRightWidth: 1,
    borderRightColor: '#e5e7eb',
    paddingTop: 16,
    paddingHorizontal: 12,
  },

  rightPane: {
    flex: 1,
    backgroundColor: '#f9fafb',
    padding: 0,
    gap: 0,
  },

  tableContainer: {
    borderRadius: 12,
    overflow: 'hidden',
    borderWidth: 1,
    borderColor: '#e5e7eb',
    backgroundColor: '#ffffff',
  },

  tableHeader: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },

  columnHeader: {
    fontWeight: 'bold',
    backgroundColor: 'transparent',
    color: '#0f172a',
    alignItems: 'flex-start',
    paddingHorizontal: 14,
    paddingVertical: 8,
    width: 260,
  },

  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },

  tableRowSelected: {
    backgroundColor: '#e8f3ff',
  },

  cell: {
    position: 'relative',
    padding: 12,
    width: 260,
    alignItems: 'flex-start',
  },

  cellTitle: {
    fontSize: TextMediumSize,
    fontWeight: '600',
    color: '#111827',
  },

  cellSubtitle: {
    fontSize: TextSmallSize,
    color: '#6b7280',
    marginTop: 4,
  },

  emptyState: {
    padding: 24,
    alignItems: 'center',
  },

  emptyStateText: {
    color: '#6b7280',
  },

  sectionHeader: {
    marginTop: 8,
    marginBottom: 8,
    paddingHorizontal: 4,
  },

  sectionTitle: {
    fontSize: TextMediumSize + 1,
    fontWeight: '700',
    color: '#0f172a',
  },

  detailCard: {
    padding: 24,
    gap: 8,
    backgroundColor: '#ffffff',
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#e5e7eb',
  },

  detailWrapper: {
    marginBottom: 12,
  },

  detailTitle: {
    fontSize: TextMediumSize,
    fontWeight: '700',
    color: '#0f172a',
  },

  detailSubtitle: {
    fontSize: TextSmallSize,
    color: '#6b7280',
  },

  trackerHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },

  trackerAvatar: {
    width: 40,
    height: 40,
    borderRadius: 20,
    backgroundColor: '#e0f2fe',
    justifyContent: 'center',
    alignItems: 'center',
  },

  trackerAvatarText: {
    color: '#0ea5e9',
    fontWeight: '700',
  },

  statusPill: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#e5e7eb',
    borderRadius: 14,
    paddingHorizontal: 10,
    paddingVertical: 6,
    gap: 6,
  },

  statusDot: {
    width: 8,
    height: 8,
    borderRadius: 4,
  },

  statusPillText: {
    color: '#111827',
    fontSize: TextSmallSize,
    fontWeight: '600',
  },

  statGrid: {
    flexDirection: 'row',
    gap: 10,
  },

  statCard: {
    flex: 1,
    padding: 12,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: '#e5e7eb',
    backgroundColor: '#f9fafb',
    minHeight: 52,
    justifyContent: 'center',
    alignItems: 'flex-start',
  },

  statLabel: {
    color: '#6b7280',
    fontSize: TextSmallSize,
    marginBottom: 4,
  },

  statValue: {
    color: '#0f172a',
    fontWeight: '600',
  },

  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 4,
  },

  detailLabel: {
    color: '#4b5563',
    fontWeight: '500',
  },

  detailValue: {
    color: '#111827',
  },

  reservationsContainer: {
    gap: 12,
  },

  reservationCard: {
    padding: 14,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#e5e7eb',
    backgroundColor: '#ffffff',
  },

  reservationRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },

  reservationTitle: {
    fontWeight: '700',
    color: '#0f172a',
  },

  reservationBadge: {
    backgroundColor: '#e0f2fe',
    color: '#0ea5e9',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 12,
    fontSize: TextSmallSize,
    overflow: 'hidden',
  },

  reservationSubtitle: {
    color: '#111827',
    fontWeight: '600',
    marginBottom: 4,
  },

  reservationMeta: {
    color: '#6b7280',
    fontSize: TextSmallSize,
    marginTop: 2,
  },

  headerStatCard: {
    backgroundColor: '#fff',
  },

  mapContainer: {
    flex: 1,
    minHeight: 320,
    borderRadius: 0,
    overflow: 'hidden',
    borderWidth: 0,
    borderColor: 'transparent',
    backgroundColor: '#ffffff',
  },
});
